<template>
  <div>
    <b-form @submit="onSubmit">
      <b-row>
        <b-col>
          <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" required v-model="addUser.login" :state="inputLoginState"  aria-describedby="input-live-help input-live-feedback" trim />
            <b-form-invalid-feedback id="input-live-feedback">
              {{ $t('Enter only english letters, numbers, at least 1 letter') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Generated password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" disabled  v-model="genPass"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="addUser.full_name"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="password" v-model="addUser.password"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Confirm password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="password" v-model="confirmPassword"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Payment in advance')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox v-model="addUser.advance_payment"/>
          </b-form-group>
          </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button type="submit" variant="success" style="float: right; width: 100px">{{ $t('Save') }}</b-button>
        </b-col>
        <b-col sm="3">
          <b-button variant="secondary" style="float: right ;width: 100px" @click="hideAddUser">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'

export default {
  data () {
    return {
      addUser: {
        'login': '',
        'password': '',
        'full_name': '',
        'is_juridical': false,
        'juridical_address': '',
        'actual_address': '',
        'flat_number': '',
        'entrance': '',
        'floor': '',
        'district': '',
        'building': '',
        'passport': '',
        'house_id': 0,
        'work_telephone': '',
        'home_telephone': '',
        'mobile_telephone': '',
        'web_page': '',
        'icq_number': '',
        'tax_number': '',
        'kpp_number': '',
        'email': '',
        'bank_id': 0,
        'bank_account': '',
        'comments': '',
        'personal_manager': '',
        'connect_date': 0,
        'is_send_invoice': false,
        'advance_payment': 0,
        'router_id': 0,
        'port_number': 0,
        'binded_currency_id': 810,
        'additional_params': [],
        'groups': [],
        'is_blocked': false,
        'balance': 0.0,
        'credit': 0.0,
        'vat_rate': 0.0,
        'sale_tax_rate': 0.0,
        'int_status': 0
      },
      genPass: null,
      confirmPassword: null
    }
  },
  methods: {
    onSubmit (event) {
      if (this.validation()) {
        event.preventDefault()
        if (this.addUser.password === this.confirmPassword) {
          axiosInstance.post(this.$store.getters.API_USERS, this.addUser).then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$emit('refreshTable', this.addUser.login)
              this.$root.$emit('makeToasts')
            }
          })
        }
      }
    },
    hideAddUser () {
      this.$emit('hideAddUser')
    },
    generatePass (length = 10) {
      this.genPass = ''
      var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      var lowercase = 'abcdefghijklmnopqrstuvwxyz'
      var numbers = '0123456789'
      var all = uppercase + lowercase + numbers
      for (var index = 0; index < length; index++) {
        var character = Math.floor(Math.random() * all.length)
        this.genPass += all.substring(character, character + 1)
      }
      this.addUser.password = JSON.parse(JSON.stringify(this.genPass))
      this.confirmPassword = JSON.parse(JSON.stringify(this.genPass))
    },
    validation () {
      if (this.addUser.login.length === 0) {
        return false
      }
      let strArray = this.addUser.login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-_/'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.addUser.login.length
    }
  },
  computed: {
    inputLoginState () {
      return this.validation()
    }
  },
  mounted () {
    this.generatePass()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/formAdd.vue